import Desktop from './includes/Desktop'
import Mobile from './includes/Mobile'

function Image({ src }: { src: string }) {
  return (
    <>
      <Desktop src={src} />
      <Mobile src={src} />
    </>
  )
}

export default Image
